import type { FC } from 'react';
import { AccordionLinkGroup } from '../AccordionLinkGroup';
import { useAboutLinks } from './useAboutLinks';

export const AccordionAboutLinks: FC = () => {
    const { data, isLoading } = useAboutLinks();
    if (isLoading || !data) return null;
    return <AccordionLinkGroup {...data} />;
};
